import { Link, NavLink } from "react-router-dom"

const Header = () => {

    const destinations = [
        {path: '/', text: 'Home'},
        {path: '/about', text: 'About'},
        {path: '/projects', text: 'Projects'},
        {path: '/contact', text: 'Contact'}
    ]

    const links = destinations.map(dest => (
        <NavLink
            to = {dest.path}
            key = {dest.path}
            end = {dest.path === '/'}
            className = {({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
            {dest.text}
        </NavLink>
    ))

    return (
        <header className="site-header">
            <Link to = '/' className="logo">Josh Simon<span>.</span></Link>
            <nav className="site-nav">
                {links}
            </nav>
        </header>
    )
}

export default Header;
